<template>
  <div class="mustlike" :class="{'wide':isPC}">
    <LeaveTel ref=LeaveTel></LeaveTel>
    <!--楼盘列表 -->
    <ul class="commlist clearfix" v-if="isList">
      <li :key="index" v-for="(item,index) in eList">
        <span @click="leaveCallClick(item.phone2,item.pkId,item.name)"><a href="javascript:void(0);" class="swtell"><i class="m-icon"></i></a></span>
        <router-link :to="{path:'estateDetail?estateId='+item.pkId}">
          <div class="bdicon">
            <i v-if="item.vrUrl&&item.vrUrl!=''" class="i-vr"></i>
            <i v-if="item.tvUrl&&item.tvUrl!=''" class="i-tv"></i>
          </div>
          <img v-lazy="item.path +'&type=1&size=240x180'" />
          <p class="mltitle">{{item.name}}</p>
          <span class="mprice"><b>{{item.price}}</b>{{item.priceUnit}}</span>
          <p class="mladdress"><i class="m-icon"></i><span v-if="isPC">[</span>{{item.stName}}-{{item.scName}}<span v-if="isPC">]{{item.positionDetail}}</span><span v-if="$store.state.domainIndex==2&&item.area&&item.area!='暂无资料'" class="jm">建面{{item.area}}</span></p>
          <p class="mtag" v-if="item.tagList">
            <span >{{item.saleStatusName}}</span>
            <span :key="i" v-for="(o,i) in item.tagList" >{{o.name}}</span>
          </p>
          <p class="mtag" v-else>
               <span >{{item.saleStatusName}}</span>
            </p>
          <p v-if="item.area&&item.area!='暂无资料'" class="mlarea">建面{{item.area?item.area + "㎡":'暂无资料'}}</p>
          <p v-else class="mlarea">{{item.area?item.area + "㎡":'暂无资料'}}</p>
        </router-link>
      </li>
    </ul>
    <!--首页猜你喜欢 -->
    <ul class="commlist hlist clearfix" v-if="isHome">
      <li :key="index" v-for="(item,index) in eList">
        <router-link :to="{path:'estateDetail?estateId='+item.pkId}">
          <div class="bdicon">
            <i v-if="item.vrUrl&&item.vrUrl!=''" class="i-vr"></i>
            <i v-if="item.tvUrl&&item.tvUrl!=''" class="i-tv"></i>
          </div>
          <img v-lazy="item.path +'&type=1&size=270x180'" />
          <p class="mltitle">{{item.name}}</p>
          <span class="mprice" v-if="item.price!=null&&item.price!=0"><b>{{item.price}}</b>{{item.priceUnit}}</span>
          <span class="mprice" v-else>售价待定</span>
          <p class="mladdress"><i class="m-icon"></i><span v-if="isPC">[</span>{{item.stName}}-{{item.scName}}<span v-if="isPC">]{{item.positionDetail}}</span></p>
          <p class="mtag" v-if="item.tagList">
            <span >{{item.saleStatusName}}</span>
            <span :key="i" v-for="(o,i) in item.tagList" >{{o.name}}</span>
          </p>
          <p class="mtag" v-else>
               <span >{{item.saleStatusName}}</span>
            </p>
          <p v-if="item.area&&item.area!='暂无资料'" class="mlarea">建面{{item.area}}</p>
          <p v-else class="mlarea">{{item.area}}</p>
        </router-link>
      </li>
    </ul>

    <!-- 楼盘列表页推荐热销楼盘 -->
    <ul class="recomlist" v-if="isRecom">
      <li :key="index" v-for="(item,index) in recomItems">
        <span @click="leaveCallClick(item.phone2,item.pkId,item.name)"><a href="javascript:void(0);" class="swtell"><i class="m-icon"></i></a></span>
        <router-link :to="{path:'estateDetail?estateId='+item.pkId}">
          <div class="bdicon">
            <i v-if="item.vrUrl&&item.vrUrl!=''" class="i-vr"></i>
            <i v-if="item.tvUrl&&item.tvUrl!=''" class="i-tv"></i>
          </div>
          <img v-lazy="item.path +'&type=1&size=240x180'" />
          <p class="mltitle">{{item.name}}</p>
          <p class="mprice" v-if="item.price==null||item.price==0">售价待定</p>
          <p class="mprice" v-else><b>{{item.price}}</b>{{item.priceUnit}}</p>
          <p class="mladdress"><i class="m-icon"></i><span v-if="isPC">[</span>{{item.stName}}-{{item.scName}}<span v-if="isPC">]{{item.positionDetail}}</span></p>
          <p class="mtag" v-if="item.tagList">
            <span :key="i" v-for="(o,i) in item.tagList" >{{o.name}}</span>
          </p>
          <p v-if="item.acreage" class="mlarea">建面{{item.acreage}}</p>
        </router-link>
      </li>
    </ul>
    <div class="noitem" style="background:none;" v-if="isRecom&&recomLength==0"><span>{{msg}}</span></div>

    <!-- 楼盘详情页猜你喜欢 -->
    <ul class="guesslist clearfix" v-if="isGuess">
      <li :key="index" v-for="(item,index) in guessItems">
        <div class="bdicon">
          <i v-if="item.vrUrl&&item.vrUrl!=''" class="i-vr"></i>
          <i v-if="item.tvUrl&&item.tvUrl!=''" class="i-tv"></i>
        </div>
        <a hre="javascript:;" @click="itemClick(item.pkId)">
          <img v-lazy="item.path +'&type=1&size=270x180'" />
        </a>
        <p class="mltitle">{{item.name}}</p>
        <p class="mladdress">{{item.stName}}-{{item.scName}}</p>
        <p class="mprice" v-if="item.price!=null&&item.price!=0"><b>{{item.price}}</b>{{item.priceUnit}}</p>
        <p class="mprice" v-else>售价待定</p>
        <span @click="$emit('takeCall',item.phone2,item.pkId,item.name)"><a href="javascript:void(0);" class="mltell">咨询热线</a></span>
      </li>
    </ul>
    <div class="noitem" v-if="isGuess&&recomLength==0"><span>{{msg}}</span></div>
  </div>
</template>

<script>
import Global from '@/components/public/Global'
import LeaveTel from '@/components/public/LeaveTel'
export default {
  name: 'PCFilter',
  inject:['reload'],
  props:{
    isPC:Boolean,
    eList:Array,
    isRecom:Boolean,
    isGuess:Boolean,
    isHome:Boolean,
    isList:Boolean,
    estateObj:Object,
  },
  components:{
    'LeaveTel':LeaveTel,
  },
  data () {
    return {
      recomItems:[],
      recomLength:'',
      guessItems:[],
      msg:'正在加载...',
      params:{
        phone:null,
        type:null,
        estateId:null,
        estateName:null,
        column:null,
        projectPkId:null
      },
      bdmapChannel: Global.channel_bdmap
    }
  },
  mounted(){
    var _this = this;
    if(_this.isRecom){
      _this.getRecom();
    }
    if(_this.isGuess){
      _this.getGuess();
    }
  },
  methods:{
    getRecom:function(){
      this.$http.get('/api/baidu/getHotEstateList').then((response)=>{
        this.recomItems = response.data.result;
        this.recomLength = this.recomItems.length;
        this.msg='暂无数据';
      }).catch((response)=>{
        console.log(response)
      })
    },
    getGuess:function(){
      let url = '/api/estate/getGuessYouLikeEstateList?estateId='+this.estateObj.pkId
        +'&price='+this.estateObj.price
        +'&location_st='+this.estateObj.fkIdLocationSt
        +'&location_sc='+this.estateObj.fkIdLocationSc
        +'&showCount=3';

      let channel = sessionStorage.getItem("channel");
      if (channel && channel.indexOf(this.bdmapChannel) !== -1) {
        url += '&channel=' + this.bdmapChannel;;
      }

      this.$http.get(url).then((response)=>{
        this.guessItems = response.data.result.estateList;
        this.recomLength = this.guessItems.length;
        this.msg='暂无数据';
      }).catch((response)=>{
        console.log(response)
      })
    },
    itemClick:function(id){
      this.$router.push({path:'/estateDetail?estateId='+id});
      this.reload();
    },
    leaveCallClick:function(phone,estateId,estateName){
      this.$refs.LeaveTel.leaveCallClick(phone,estateId,estateName,'楼盘');
    }
  }
}
</script>

<style scoped>
.mustlike{padding-left:0;padding-right:0;padding-bottom:0;}
.mustlike li{display:block;position:relative;padding:15px;padding-left:155px;line-height:20px;min-height:90px;position:relative;}
.mustlike li+li{border-top:1px solid #ececec;}
.mustlike img{position:absolute;left:15px;top:15px;width:130px;height:90px;border-radius:3px;}
.mltitle{font-size:15px;line-height:22px;font-weight:700;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.mladdress,.mlarea{font-size:12px;color:#777;margin-right:40px;}
.mladdress .m-icon{width:10px;height:12px;background-position:-96px 0;margin-right:5px;}
.mprice{position:absolute;top:15px;right:15px;}
.mtag{height:22px;overflow:hidden;margin-top:3px;margin-right:40px;}
.recomlist{background:none;}
.recomlist li{margin-top:10px;background:#fff;padding-left:150px;padding-right:10px;}
.recomlist li+li{border:0;}
.recomlist img{left:10px;}
.recomlist .mprice{position:static;margin-top:2px;margin-bottom:4px;}
.mltell{position:absolute;top:15px;right:0;padding:0 8px;line-height:28px;font-size:12px;border-radius:2px;background:linear-gradient(90deg, #ff4d30 0%, #ff845e 100%);color:#fff;}
.mlarea{line-height:16px;margin-top:6px;}
@media (max-width:768px){
  .mustlike ul{background:#fff;}
  .mustlike .recomlist{background:none;padding:0 15px;}
  .guesslist li{padding:15px 0 15px 115px;min-height:75px;}
  .guesslist img{left:0;height:75px;width:100px;}
  .guesslist .mprice{position:static;}
  .guesslist .mltitle{margin-top:2px;}
  .guesslist p+p{margin-top:5px;}
  .commlist .mltitle{margin-right:80px;}
  .swtell{position:absolute;right:15px;bottom:15px;}
  .swtell .m-icon{width:30px;height:30px;background-position:0 -64px;background-size:184px;display:block;}
  .hlist .mltitle,.hlist .mltag,.hlist .mladdress{margin-right:0;}
  .hlist .mprice{position:static;margin-top:2px;display:block;}
  .bdicon{position:absolute;left:25px;bottom:25px;z-index:1;}
  .bdicon i{float:left;width:21px;height:21px;margin-right:5px;background:rgba(0,0,0,.2) url(../../assets/images/estatelist_icon.png);background-size:auto 21px;border-radius:45%;box-shadow:0 0 5px rgba(0,0,0,.5)}
  .bdicon i.i-tv{background-position: -22.5px 0;}
  .hlist .bdicon{left:23px;bottom:28px;}
  .guesslist .bdicon{left:8px;}
  .recomlist .bdicon{left:18px;bottom:23px;}
}
@media (min-width:769px){
  .wide ul{margin-top:25px;}
  .wide li{display:inline-block;padding:0;padding-top:148px;width:22.75%;float:left;margin-left:3%;min-height:0;}
  .wide li:first-child{margin-left:0;}
  .wide li+li{border:0;}
  .wide img{width:100%;height:140px;top:0;left:0;}
  .wide .mladdress,.wide .mltell{display:none;}
  .wide .mprice{top:auto;bottom:1px;right:0;margin-top:0;}
  .wide .mltag{display:none;}
  .wide li a{cursor:pointer;}
  .swtell{display:none;}
  .wide .mltitle{margin-right:80px;}
  .hlist .mtag,.hlist .mlarea{display:none;}
}
@media (min-width:1000px){
  .wide li{padding-top:188px;}
  .wide img{height:180px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/EstateList.vue